var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApiIconApiFocus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "241px",
    height: "160px",
    viewBox: "0 0 241 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "API_icon_API_newFocus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "API_icon_API_newFocus",
    transform: "translate(0.500000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lv2_Icon_Frame_focus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Frame_focus"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A48923",
    x: 0,
    y: 0,
    width: 240,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#1A4480",
    x: 8,
    y: 8,
    width: 224,
    height: 144
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(47.499948, 29.512158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hUzEZV",
    transform: "translate(0.000000, 8.487811)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8780682,80.4927411 C13.516839,80.4927411 1.77536714,70.0598067 0.707317584,57.2432121 C-0.445610078,43.9668611 9.25878718,32.7488042 23.3414803,30.8885589 L23.3414803,30.8249003 C25.2653841,24.9541644 27.9178251,18.3902572 35.4861232,14.1463517 C40.1905285,11.5137722 45.4865061,10.1191972 50.8773539,10.0934219 C55.9398996,10.0993218 60.9262245,11.3270981 65.4127302,13.6724489 C72.2595644,5.11390614 81.2707905,0.594146771 91.5834808,0.594146771 C93.4516606,0.597426917 95.3170237,0.739279623 97.1642166,1.01853732 C112.435203,3.30317312 122.02643,11.6283011 124.898139,25.1663597 C125.362634,27.2969646 125.630184,29.4657756 125.697408,31.6453887 C137.389368,35.0405131 144.915227,45.1480814 144.420104,56.8046752 C143.974494,67.414439 135.359366,77.1400558 123.907894,79.9198139 C122.387903,80.2607121 120.83241,80.4174488 119.274964,80.3866435 L118.12911,80.3866435 L117.004475,80.3866435 C109.294713,80.3866435 101.56609,80.3866435 93.8186044,80.3866435 L72.4929792,80.3866435 C68.0793175,80.3866435 63.6656558,80.3701394 59.2519941,80.3371312 L58.7073595,80.3371312 C54.2936978,80.3371312 49.8163775,80.287619 45.3178376,80.287619 C38.3578326,80.287619 32.6709992,80.3442044 27.4156296,80.4715216 L26.8780682,80.4927411 Z M50.9268661,18.2487937 C46.9164726,18.2596563 42.9759747,19.2995776 39.4824676,21.2690398 C34.955635,23.7800172 33.0670971,27.4297759 31.1714859,33.2934387 L31.0795347,33.5975853 C30.6763636,34.8990496 29.6012409,38.3790521 24.9541644,38.8883208 C15.0092791,39.984663 8.08463999,47.5741807 8.83439663,56.5712604 C9.54171421,65.1298032 17.8244031,72.3585889 26.8922146,72.3585889 L27.2953856,72.3585889 C32.6356333,72.2383449 38.3931985,72.1746863 45.4310085,72.1746863 C49.9719873,72.1746863 54.4917467,72.1746863 58.9549207,72.2241985 L59.3580917,72.2241985 C63.7528916,72.2524913 68.1476915,72.2689953 72.5424915,72.2737108 L93.8751898,72.2737108 C101.608529,72.2737108 109.337152,72.2737108 117.06106,72.2737108 L118.28472,72.2737108 L119.317403,72.2737108 C120.226745,72.3009749 121.136111,72.220248 122.02643,72.0332228 C129.997899,70.0951726 135.995952,63.5454118 136.293025,56.4722359 C136.625465,48.6351571 131.454973,41.8024692 123.426918,39.4966139 C119.656916,38.4073448 117.690573,35.9953919 117.584475,32.3173404 C117.546766,30.4732603 117.328818,28.6372866 116.933743,26.8356292 C114.776424,16.7139145 107.915444,10.899764 95.9688499,9.11025049 C94.4891081,8.88762198 92.9949942,8.77414498 91.4986027,8.77073805 C83.5271335,8.77073805 76.7510311,12.307326 71.3612711,19.3805018 C69.8546846,21.3539179 68.0793175,22.3512357 66.0988283,22.3512357 C64.7398899,22.2995786 63.4151488,21.9106638 62.2439474,21.2195275 C58.7647512,19.2927659 54.8544322,18.2780783 50.8773539,18.2700132 L50.9268661,18.2487937 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.1129537,89.071509 L37.1129537,63.1624659",
    id: "Path",
    stroke: "#1A4480",
    strokeWidth: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.088856,89.071509 L104.088856,63.071509",
    id: "Path",
    stroke: "#1A4480",
    strokeWidth: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.272002,88.9805521 L70.272002,63.071509",
    id: "Path",
    stroke: "#1A4480",
    strokeWidth: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1134509,18.6056676 L50.1134509,40.9041759",
    id: "Path",
    stroke: "#1A4480",
    strokeWidth: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7320174,9.17291467 L91.7320174,40.9041759",
    id: "Path",
    stroke: "#1A4480",
    strokeWidth: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(5.248296, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 63.078582)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "9.10317731 36.4127092 31.8646572 36.4127092 31.8646572 3.02731926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0688058,3.19000231 C35.0688058,1.42821268 33.6405932,3.15303339e-14 31.8788035,3.15303339e-14 C30.1170139,3.15303339e-14 28.6888012,1.42821268 28.6888012,3.19000231 C28.6888012,4.95179193 30.1170139,6.38000461 31.8788035,6.38000461 C33.6389794,6.37611471 35.0649159,4.95017816 35.0688058,3.19000231 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round",
    cx: 4.19439328,
    cy: 36.7027095,
    r: 4.19439328
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(95.650464, 63.078489)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "25.9515754 36.4128025 3.19009555 36.4128025 3.19009555 3.02741251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38009786,3.19009555 C6.38009786,1.89986006 5.60287875,0.736669458 4.41085658,0.242917711 C3.21883442,-0.250834037 1.84675755,0.0220890202 0.934423287,0.934423287 C0.0220890202,1.84675755 -0.250834037,3.21883442 0.242917711,4.41085658 C0.736669458,5.60287875 1.89986006,6.38009786 3.19009555,6.38009786 C4.95027141,6.37620795 6.37620795,4.95027141 6.38009786,3.19009555 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round",
    cx: 30.8603595,
    cy: 36.7028027,
    r: 4.19439328
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(60.475653, 63.071509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.54805207,32.5153894 L4.54805207,6.09707758",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "8.7848844 7.33488335 4.54805207 2.84217094e-14 0.318292913 7.33488335"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round",
    cx: 4.19439328,
    cy: 36.7097826,
    r: 4.19439328
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(13.007570, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "9.10317731 4.48439349 31.857584 4.48439349 31.857584 37.8697835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6675817,37.7071004 C28.6647212,39.0014796 29.4426132,40.1698649 30.6379185,40.6665247 C31.8332238,41.1631845 33.2100566,40.8901061 34.1253231,39.9748395 C35.0405897,39.059573 35.313668,37.6827402 34.8170083,36.4874349 C34.3203485,35.2921296 33.1519632,34.5142376 31.857584,34.5170981 C30.0974081,34.520988 28.6714716,35.9469246 28.6675817,37.7071004 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round",
    cx: 4.19439328,
    cy: 4.19439328,
    r: 4.19439328
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(83.293719, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "25.9514822 4.48439349 3.19000231 4.48439349 3.19000231 37.8697835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.84217094e-14,37.7071004 C2.84217094e-14,39.4688901 1.42821268,40.8971027 3.19000231,40.8971027 C4.95179193,40.8971027 6.38000461,39.4688901 6.38000461,37.7071004 C6.38000461,35.9453108 4.95179193,34.5170981 3.19000231,34.5170981 C1.42982645,34.520988 0.00388990563,35.9469246 2.84217094e-14,37.7071004 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinejoin: "round",
    cx: 30.8602662,
    cy: 4.19439328,
    r: 4.19439328
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiIconApiFocus);
export default __webpack_public_path__ + "static/media/API_icon_API_Focus.006dfe234274bbe65467b996223dd2f4.svg";
export { ForwardRef as ReactComponent };